import { Head, router, usePage } from "@inertiajs/react";
import { useEffect } from "react";

import Layout from "/AdminLayout";
import ProjectForm from "/components/Admin/ProjectForm";

import { useToast } from "/utils/toast-context.jsx";
import createProjectStore from "/hooks/stores/projectStore";

const EditProject = ({
  project,
  errors,
}) => {
  const useProjectStore = createProjectStore(project);
  const { successToast } = useToast();

  const handleSubmit = (state, preview = false) => {
    const data = useProjectStore.getState().getAllData();
    data.state = state;
    if (preview)
      data.preview = preview;
    router.put(
      `/admin/projects/${project.id}`,
      data,
      {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    );
  };

  return (
    <>
      <Head>
        <title>Редактирование проекта</title>
      </Head>
      <ProjectForm
        onSubmit={handleSubmit}
        useStore={useProjectStore}
        errors={errors}
      />
    </>
  );
}

EditProject.layout = (page) => <Layout children={page} />;

export default EditProject;
